import { PendingInvitationBanner } from "@/features/accounts/components/PendingInvitationBanner";
import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { AppTopbar } from "./AppTopbar";

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    document.getElementById("boot-loader")?.remove();
  }, []);

  return (
    <>
      <PendingInvitationBanner />

      <div className="flex h-screen bg-app-bg font-sans text-app-ink-1">
        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 z-20 bg-black/40 md:hidden"
            onClick={() => setSidebarOpen(false)}
            onKeyDown={(e) => {
              if (e.key === "Escape") setSidebarOpen(false);
            }}
          />
        )}

        {/* Sidebar — fixed on mobile (drawer), static column on desktop */}
        <div
          className={`fixed inset-y-0 left-0 z-30 w-[232px] transform transition-transform duration-200 md:static md:block md:translate-x-0 ${
            sidebarOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <AppSidebar onClose={() => setSidebarOpen(false)} />
        </div>

        {/* Main content */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <AppTopbar onMenuClick={() => setSidebarOpen((o) => !o)} />
          <main className="mx-auto w-full max-w-7xl flex-1 overflow-auto px-4 py-6 md:px-8 xl:px-10">
            <Outlet />
          </main>
        </div>
      </div>
    </>
  );
}
